import { render, staticRenderFns } from "./NameScreeningStatus.vue?vue&type=template&id=60151e7e"
import script from "./NameScreeningStatus.vue?vue&type=script&lang=js"
export * from "./NameScreeningStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports